// This file applies to API-V2, Dev-Center-API-V2, and all Frontend APPs
const isShutDown = (tenantId) => {
  if (['tyson-louths-demo-winery'].includes(tenantId)) {
    return true;
  }
  return false;
};

export const productTeam = [
  'development',
  'noah-sandbox-account',
  'andreas-demo-winery',
  'jason-demo-site',
  'jason-demo-site-db4',
  'sandbox-c7-development-josh',
  'commerce7development',
  'joshsandbox',
  'peter-sandbox-account',
  'sandbox-yves',
  'test-tenant-id',
  'sandbox-felipe-soares',
  'sandbox-gabriel-carvalho',
  'sandbox-guilherme-moreira',
  'commerce11',
  'sandbox-nickey-gertsberg',
  'sandbox-gisele-pecapedra'
];

const getShutdownWindow = () => ({
  startTime: '2023-04-13T05:00:00.000Z',
  endTime: '2023-04-13T11:00:00.000Z' // 4:00am PST
});

const isNickname = (tenantId) => {
  if (
    [
      'development',
      'opus-one-winery',
      'chappellet-winery',
      'chappellet-uat',
      'chappellet-winery-dev',
      'chappellet-winery-qa'
    ].includes(tenantId)
  ) {
    return true;
  }
  return false;
};

const isPacificUnion = (tenantId) => {
  if (
    [
      'promontory',
      'promontory-testing',
      'promontory-production',
      'bond',
      'bond-production',
      'bond-testing',
      'harlan-estate',
      'harlan-estate-testing',
      'harlan-estate-production',
      'the-mascot',
      'the-mascot-production',
      'the-mascot-testing'
    ].includes(tenantId)
  ) {
    return true;
  }
  return false;
};

const isAmazonFraud = (tenantId) => {
  if (
    [
      'development',
      'testing',
      'jason-demo-site-db4',
      'aloria-vineyards',
      'sangiacomo-family-wines',
      'three-sticks-wines',
      'cline-cellars',
      'michael-ros-winery',
      'boisset-collection',
      'doffo-wines-llc',
      'peju-family-winery',
      'gibbston-valley-winery',
      'forthright-winery',
      'copia-vineyards-and-winery',
      'van-duzer-vineyards',
      'efeste',
      'hugh-hamilton-wines',
      'cristom-vineyards',
      'la-frenz-estate-winery',
      'wiens-cellars',
      'michael-shaps-winery',
      'dresser-winery-by-gelfand-vineyards',
      'shafer-vineyards',
      'uva-mira-mountain-vineyards',
      'corlis-winery',
      'milea-estate-vineyard',
      'mount-palomar-winery',
      'kenzo-estate1',
      'dunstan-wines',
      'paul-cluver',
      'ballandean-estate-wines',
      'shaw-smith',
      'wiens-cellars',
      'boich-family-cellar',
      'avalle',
      'mcgregor-vineyard',
      'hagafen-cellars1',
      'torr-na-lochs-vineyard-winery',
      'ridge-vineyards',
      'bella-grace-vineyards',
      'dk-wine-group',
      'dirty-laundry-vineyard',
      'copper-cane',
      'texas-southwind',
      'the-roost-wine-company',
      'michael-ros-winery',
      'active-ice',
      'bingham-family-cellars',
      'holm-oak-vineyards',
      'harvest-ridge-winery',
      'crimson-wine-shop',
      'donum',
      'starfield-vineyards',
      'gallo-wine-shop',
      'maverick-estate-winery',
      'singing-water-vineyards',
      'dancin-vineyards1',
      'wente-family-estates',
      'murrietas-well',
      'winery-on-the-gruene',
      'levendi-winery',
      'occasio-winery',
      'augusta-vin-llc',
      'peltier-winery',
      'william-chris-vineyards',
      'doffo-wines-llc',
      'weathereye-vineyards',
      'tranquillity-vineyard',
      'gleason-family-vineyards-lp',
      'behrens-family',
      'baldacci-family-vineyards',
      'relic-cellars',
      'lithica-wine-partner-account',
      'lunabean-media',
      'somerston',
      'korbel-champagne-cellars1',
      'bayernmoor-cellars',
      'russian-river-vineyards',
      'the-vineyard-house-llc',
      'proxy-ai-inc',
      'wilson-hurst-llc-dba-truett-hurst-winery',
      'sosie-wines',
      '00-wines',
      'joie-ventures-inc',
      'maze-row',
      'language-of-yes',
      'offscript',
      'massican-winery',
      'denner-vineyards',
      'talbott-vineyards',
      'j-vineyards',
      'pahlmeyer',
      'louis-m-martini',
      'orin-swift-cellars',
      'rombauer-vineyards',
      'colin-s-sandbox',
      'sandbox-curstin-priestley',
      'rhinory-llc',
      'ross-cordoviz-sandbox-account',
      'sandbox-brandon-silva',
      'sandbox-justin-chun',
      'sandbox-monica-ridge',
      'sandbox-teddy-matta',
      'britney-demo-account',
      'robert-ziraldo-sandbox-account',
      'margaret-test-site',
      'sandbox-amanda-evans',
      'spencer-rosko-sandbox-account1',
      'sandbox-elise-herrera',
      'peter-sandbox-account',
      'vanesa-cureatz-sandbox-account',
      'jennifers-v2-sandbox',
      'sandbox-sara',
      'sandbox-luke',
      'sandbox-giovanna-barino',
      'sandbox-artur-antoniazzi',
      'sandbox-edgar-flores',
      'sandbox-ken-vandegrift',
      'sandbox-emily-mccutcheon',
      'sandbox-curstin-priestley',
      'sandbox-garner-ozaeta',
      'shire-tiree',
      'sandbox-savannah-romero',
      'allyson-proske-sandbox',
      'sandbox-rachael-sloane',
      'andrew-russo-test-site',
      'robertbearcedemosite',
      'sandbox-tyler-larkin',
      'nikola-gavrilovski-sandbox',
      'andreas-demo-winery',
      'europa-village-winery-resort'
    ].includes(tenantId)
  ) {
    return true;
  }
  return false;
};

const hasCombinePOSAndReservations = (tenantId) => {
  const allowedTenants = [];
  if (allowedTenants.includes(tenantId) || productTeam.includes(tenantId)) {
    return true;
  }
  return true;
};

export {
  getShutdownWindow,
  isNickname,
  isPacificUnion,
  isShutDown,
  isAmazonFraud,
  hasCombinePOSAndReservations
};
